import type { QueryFunction } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { useAppState } from '../../AppStateProvider';
import type { CompanyCrmInfo } from '../../domain/company';

import { companyApi } from './api';
import companyQueryKey from './companyQueryKey';

export const useCompanyCrmInfoQuery = (domain: string) => {
  const { isOpen } = useAppState();

  const fetchCompanyCrmInfo: QueryFunction<CompanyCrmInfo, string[]> = ({ queryKey: [, , queryDomain], signal }) =>
    companyApi.getCompanyCrmInfo(queryDomain, signal);

  return useQuery({
    queryKey: companyQueryKey.companyCrmInfo(domain),
    queryFn: fetchCompanyCrmInfo,
    enabled: isOpen && !!domain,
  });
};
